import globalText from "../../../../utils/globalText";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../../../assets/Icons";
import InternalTransactionViewAll from "../../../../containers/Transactions/InternalTransactions/InternalTransactionViewAll";
import { useDispatch, useSelector } from "react-redux";
import CommonToast from "../../../_utils/CommonToast";
import { useState } from "react";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider";
import UniversalRefreshToast from "../../../_utils/UniversalRefreshToast";
import { internalTransactionsReject } from "../../../../redux/features/transactions/internalTransactions";
import { toast } from "react-toastify";
import {
  internalAccountDetailsById,
  rejectInternalAccount,
} from "../../../../redux/features/accounts/internalAccount";
import { useNavigate } from "react-router-dom";
import SmallPopupWithInput from "../../../_utils/CommonSmallPopupWithInput";
import { scheduledInternalReject } from "../../../../redux/features/transactions/scheduleInternalTransactions";
import ScheduleInternalTransactionViewAllPopup from "../../../Transactions/ScheduleInternalTransaction/ScheduleInternalTransactionViewallpopup";

const InternalRejectAllPopup = ({
  setShowRejectPopup,
  setAssociateType,
  setDeclineReason,
  setRejectFlowType,
  declineReason,
  associateType,
  AccountId,
  setErrorStrip,
  setViewIntData,
  type,
  closeBeneAccountDetailModal,
  pendingTxnPopup,
  setPendingTxnPopup,
  handleClosePopup,
  setShowScheduleTxnPopup,
  showScheduleTxnPopup,
  showDeclinePopup,
  setShowDeclinePopup,
  allAccounts,
  associatePopupDate,
  updateAllAccounts,
  showLoader,
  setShowLoader
}) => {
  const services = useSelector((state) => state.refreshToken.services);

  const {
    internalAccountDetailsData,
    rejectInternalAccountLoading,
  } = useSelector((state) => state.internalAccount);

  const {
    internalTransactionsViewAllData,
    internalTransactionsViewAllLoading,
  } = useSelector((state) => state?.internalTransactions);

  const { scheduledInternalViewData, scheduledInternalViewLoading } =
    useSelector((state) => state?.scheduleInternalTransactions);

  const [isFocused, setIsFocused] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const internalAccount = internalAccountDetailsData?.internal_accounts?.[0];

  const hasAccess =
    services?.includes("AInternalTxn") || services?.includes("Admin");

  const hasScheduleAccess =
    services?.includes("IAScheduledTxn") || services?.includes("Admin");

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === GlobalConfiguration.lengthCheckZero) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const handleInputChange = (event) => {
    const value = event.target.value?.replace(/\s+/g, " ").trimStart() || "";

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
 

    if (sanitizedValue.length <= GlobalConfiguration.inputMaxLength) {
      setDeclineReason(sanitizedValue);
    }
  };



  const handleConfirmAlert = async () => {
    let openedSchedules = false;
    setShowLoader(true);

    try {
      const AccountIdData = declineReason;
      let allTxnId = [];

      allTxnId =
        !internalTransactionsViewAllLoading &&
        internalTransactionsViewAllData?.transactions?.length >
          GlobalConfiguration.lengthCheckZero
          ? internalTransactionsViewAllData?.transactions.map(
              (data) => data?.txn_id,
            )
          : [];

      UniversalRefreshToast("Rejecting transaction");

      let data = null;

      if (allTxnId.length > GlobalConfiguration.lengthCheckZero) {
        data = await dispatch(
          internalTransactionsReject({
            id: allTxnId,
            rejection_reason: AccountIdData,
          }),
        );
      }

      if (data?.payload?.status === false) {
        setShowRejectPopup(false);
        const errorMsg = data?.payload?.errors?.user_unauthorized
          ? data?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data?.payload?.errors?.base) &&
              Array.isArray(data?.payload?.errors?.base[0]?.errors)
            ? data.payload.errors.base[0].errors[0]
            : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

        CommonToast({
          text: errorMsg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        return;
      }

      if (
        data?.payload?.status === true ||
        allTxnId.length === GlobalConfiguration.lengthCheckZero
      ) {
        // setShowRejectPopup(false);
        setShowDeclinePopup(false);
        setPendingTxnPopup(false);
        toast.dismiss();
        CommonToast({
          text: "Transactions rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });

        const currentAccountId = AccountId;

        if (type === "internalAccountApproval") {
          const updatedData = allAccounts?.map((item) => {
            if (item.id === associatePopupDate?.accId) {
              return {
                ...item,
                pending_internal_transactions: "N",
              };
            }
            return item;
          });

          if (associateType === "rejectAccount") {
            allAccounts?.forEach((item) => {
              if (item.id === associatePopupDate?.accId) {
                if (item?.pending_scheduled_internal_transactions === "Y") {
                  setTimeout(() => {
                    setShowScheduleTxnPopup(true);
                  }, IntervalConfiguration.intervalMedium);
                } else {
                  handleInternalAccountrejectSchedule(
                    associatePopupDate?.accId,
                    declineReason,
                  );
                }
              }
            });
          }
          updateAllAccounts(updatedData);
        } else {
          if (associateType === "rejectAccount") {
            const refreshed = await dispatch(
              internalAccountDetailsById({ id: currentAccountId }),
            );

            const pendingScheduleFlag =
              refreshed?.payload?.internal_accounts?.[
                GlobalConfiguration.lengthCheckZero
              ]?.pending_scheduled_internal_transactions;
            if (pendingScheduleFlag === "Y") {
              openedSchedules = true;
              setAssociateType("rejectAccount");
              setShowScheduleTxnPopup(true);
            } else {
              await handleInternalAccountreject({
                AccountId,
                declineReason,
              });
            }
          } else if (associateType === "InternalTxn") {
            await dispatch(
              internalAccountDetailsById({ id: currentAccountId }),
            );
          }
        }
      } else if (data?.payload === undefined) {
        setShowRejectPopup(false);
        CommonToast({
          text: "An error occurred while taking action on this account",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    } catch (error) {
      console.error(error);
      CommonToast({
        text: "Something went wrong. Please try again",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    } finally {
      setShowLoader(false);
      if (associateType === "InternalTxn" && !openedSchedules) {
        setDeclineReason("");
      }
    }
  };

    const handleInternalAccountrejectSchedule = async (id, rejection_reason) => {
    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    if (
      !rejectInternalAccountLoading ||
      rejectInternalAccountLoading === null
    ) {
      const data = await dispatch(
        rejectInternalAccount({ id, rejection_reason }),
      );
      if (
        data?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "IAAccount",
          },
        });
        return;
      }

      setShowLoader(true);
      await new Promise((resolve) => {
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
      });


      if (data?.payload?.status === false) {
        let errorMsg = "";
        if (data?.payload?.errors?.internal_account?.[0]) {
          errorMsg = data?.payload?.errors?.internal_account[0];
        } else if (data?.payload?.errors?.bank_account_number?.[0]) {
          errorMsg = data?.payload?.errors?.bank_account_number[0];
        } else {
          errorMsg = "An unknown error occurred.";
        }
        const updatedData = allAccounts?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "error" : "pending",
              rejected_on:
                data.payload.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_on
                  : "",
              rejected_by_name:
                data.payload.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_by_name
                  : "",
              rejection_reason: rejection_reason,
              error:
                item.error === "false" && data?.payload?.status === false
                  ? "true"
                  : "false",
              message: data?.payload?.status === false ? errorMsg : "",
              pending_internal_transactions:
                associateType === "rejectAccount" ? "N" : "Y",
              pending_scheduled_internal_transactions:
                associateType === "rejectAccount" ? "N" : "Y",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);
        // setShowPopup(false);
        setShowLoader(false);
        setDeclineReason("");
        setShowRejectPopup(false);

        CommonToast({
          text: errorMsg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });
      } else {
        const updatedData = allAccounts.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "rejected" : "pending",

              rejected_on:
                data?.payload?.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_on
                  : "",
              rejected_by_name:
                data?.payload?.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_by_name
                  : "",
              rejection_reason: rejection_reason,
              error:
                item?.error === "false" && data?.payload?.status === false
                  ? "true"
                  : "false",
              message:
                item?.message === "" && data?.payload?.status === false
                  ? data?.payload?.errors?.internal_accounts[0]
                  : "",
              pending_internal_transactions:
                associateType === "rejectAccount" ? "N" : "Y",
              pending_scheduled_internal_transactions:
                associateType === "rejectAccount" ? "N" : "Y",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);
        setShowLoader(false);
        setDeclineReason("");
        setShowRejectPopup(false);
        if (data?.payload?.status === true) {
          CommonToast({
            text: "Account rejected successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
          });
        }
        setShowDeclinePopup(false);
      }
    }
  };

  const handleInternalAccountreject = async (id, rejectionReason) => {
    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    if (
      !rejectInternalAccountLoading ||
      rejectInternalAccountLoading === null
    ) {
      const data = await dispatch(
        rejectInternalAccount({
          id: AccountId,
          rejection_reason: declineReason,
        }),
      );

      if (
        data?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "IAAccount",
          },
        });
        return;
      }

      await new Promise((resolve) => {
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
      });

      if (data?.payload?.status === false) {
        let errorMsg = "";

        if (
          data?.payload?.errors?.internal_account?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          errorMsg =
            data?.payload?.errors?.internal_account?.[
              GlobalConfiguration.lengthCheckZero
            ];
        } else if (
          data?.payload?.errors?.bank_account_number?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          errorMsg =
            data?.payload?.errors?.bank_account_number?.[
              GlobalConfiguration.lengthCheckZero
            ];
        } else if (data?.payload?.errors?.beneficiary_account) {
          errorMsg =
            data?.payload?.errors?.beneficiary_account?.[
              GlobalConfiguration.lengthCheckZero
            ];
        } else {
          errorMsg = "An unknown error occurred.";
        }

          setErrorStrip(errorMsg);  
        setShowDeclinePopup(false);
        setShowLoader(false);
        setDeclineReason("");
        setShowRejectPopup(false);

        const errMsg = errorMsg;

    
          const updatedAccounts =
            data?.payload?.internal_accounts ||
            internalAccountDetailsData?.internal_accounts ||
            [];

          if (updatedAccounts.length === GlobalConfiguration.lengthCheckZero) {
            setViewIntData([
              {
                ...(internalAccount || {}),
                errorMsg: errMsg,
              },
            ]);
          } else {
            const updatedData = updatedAccounts.map((account, index) =>
              index === GlobalConfiguration.lengthCheckZero &&
              !account?.errorMsg
                ? {
                    ...account,
                    errorMsg: errMsg,
                  }
                : account,
            );

            setViewIntData(updatedData);
          }
        

        toast.dismiss();

        CommonToast({
          text: errorMsg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else {
  
        setDeclineReason("");
        setShowRejectPopup(false);

        if (data?.payload?.status === true) {
          toast.dismiss();

          CommonToast({
            text: "Account rejected successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
          });
        }

        await dispatch(
          internalAccountDetailsById({
            id: AccountId,
          }),
        );

        setShowDeclinePopup(false);

        if (type === "bene_account_detail_modal") {
          await new Promise((resolve) => {
            setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
          });

          closeBeneAccountDetailModal();
          // await payload?.onAccountUpdated?.();
        }
              setShowLoader(false);
      }
    }
  };

  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setShowLoader(true);

    const accountInfo = await dispatch(
      internalAccountDetailsById({ id: AccountId }),
    );
    if (
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_internal_transactions === "Y" &&
      (accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_scheduled_internal_transactions === "Y" ||
        accountInfo?.payload?.internal_accounts?.[0]
          ?.pending_scheduled_internal_transactions === "N")
    ) {
      setShowDeclinePopup(false);
      setPendingTxnPopup(true);
      setShowLoader(false);
    } else if (
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_internal_transactions === "N" &&
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_scheduled_internal_transactions === "Y"
    ) {
      setShowDeclinePopup(false);
      setShowScheduleTxnPopup(true);
      setShowLoader(false);
    } else {
      if (type === "internalAccountApproval") {
        handleInternalAccountrejectSchedule(AccountId,AccountIdData)
      } else {
        handleInternalAccountreject(AccountId, AccountIdData);
      }
      
    }
  };

  const handleRejectScheduleInternalTxn = async () => {
    setShowLoader(true);

    let id2 =
      !scheduledInternalViewLoading &&
      scheduledInternalViewData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? scheduledInternalViewData?.transactions.map((data) => data?.txn_id)
        : [];

    if (id2.length === GlobalConfiguration.lengthCheckZero) {
      setShowLoader(false);
      return;
    }

    try {
      const data2 = await dispatch(
        scheduledInternalReject({
          id: id2,
          reason: declineReason,
        }),
      );

      UniversalRefreshToast("Rejecting transaction");

      if (data2?.payload?.status === false) {
        const errorMsg2 =
          data2?.payload?.errors?.user_unauthorized?.[
            GlobalConfiguration.lengthCheckZero
          ] ||
          (Array.isArray(data2?.payload?.errors?.base) &&
          Array.isArray(
            data2?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
              ?.errors,
          )
            ? data2.payload.errors.base[GlobalConfiguration.lengthCheckZero]
                .errors[GlobalConfiguration.lengthCheckZero]
            : data2?.payload?.errors?.base?.[
                GlobalConfiguration.lengthCheckZero
              ]) ||
          "Unknown error occurred";

        CommonToast({
          text: errorMsg2,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else if (data2?.payload?.status === true) {
        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });
        setShowScheduleTxnPopup(false);
        setShowDeclinePopup(false);

        if (type === "internalAccountApproval") {
          const updatedData = allAccounts?.map((item) => {
            if (item.id === associatePopupDate?.accId) {
              return {
                ...item,
                pending_scheduled_internal_transactions: "N",
              };
            }
            return item;
          });

          updateAllAccounts(updatedData);
        } else {
          const currentAccountId = AccountId;

          await dispatch(internalAccountDetailsById({ id: currentAccountId }));
        }
        if (associateType === "rejectAccount") {
          if (type === "internalAccountApproval") {
                   await handleInternalAccountrejectSchedule(AccountId, declineReason);
          } else {
              await handleInternalAccountreject(AccountId, declineReason);
               }
        
        }
      }
    } catch (error) {
      console.error("Error rejecting schedules:", error);
      CommonToast({
        text: "Something went wrong while rejecting schedules",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    } finally {
      setShowLoader(false);
      setDeclineReason("");
      setAssociateType("");
    }
  };



  return (
    <>
      {showDeclinePopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle={
              associateType === "InternalTxn"
                ? globalText.REJECTING_TRANSACTIONS
                : associateType === "scheduleInternalTxn"
                  ? globalText?.REJECTING_SCHEDULES
                  : globalText?.REJECT_ACCOUNT
            }
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle={globalText?.PROVIDE_REJECT_REQUEST_REASON_PROMPT}
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteText={globalText?.MINIMUM_TEN_CHARACTER_REQUIRED_MGS}
            inputPlaceholder={globalText?.REASON}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (showLoader) return;
              handleInputChange(e);
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              if (!showLoader) {
                setDeclineReason("");
                setShowDeclinePopup(false);
                handleClosePopup();
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (associateType === "scheduleInternalTxn") {
                handleRejectScheduleInternalTxn();
              } else if (associateType === "InternalTxn") {
                handleConfirmAlert();
              } else {
                handleRejectTransactionChecker(AccountId, declineReason);
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.panLength
            }
            btnTwoInActiveVariantNeeded
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            bulletPoints={
              associateType === "InternalTxn"
                ? [
                    "Transaction will be rejected, and distribution will not be initiated.",
                    "Transaction cannot be edited but can be recreated.",
                  ]
                : associateType === "scheduleInternalTxn"
                  ? [
                      "Once rejected, no transaction will be created.",
                      "Rejected schedules cannot be edited. Create a new schedule instead.",
                    ]
                  : [
                      "New schedules and transactions cannot be created for this account.",
                      "Before rejecting this account, reject all associated transactions and schedules.",
                      "Users can edit the rejected account to update details.",
                    ]
            }
          />
        </div>
      )}

      {pendingTxnPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-max ">
          <LargePopupRedirect
            headerTitle={globalText?.ASSOCIATED_TRANSACTIONS_FOUND}
            headersubtext={globalText?.LINKED_TXNS_REJECTION_WARNING}
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setPendingTxnPopup(false);
              setShowDeclinePopup(false);
              setAssociateType("");
              setDeclineReason("");
              if (type === "internalAccountApproval") {
                 handleClosePopup()
              }
             
            }}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              hasAccess
                ? globalText?.REJECT_ALL_NOTE
                : globalText?.CONTACT_TO_REJECT_TRANSACTIONS
            }
            isbottomSectionneed={true}
            btnText={globalText?.REJECT_ALL}
            confirmbtnrequired={true}
            handleFunction={() => {
              const servicesReq = ["AInternalTxn"];

              if (servicesReq.some((service) => services.includes(service))) {
                if (associateType === "InternalTxn") {
                  if (
                    declineReason &&
                    declineReason.length >= GlobalConfiguration.panLength
                  ) {
                    handleConfirmAlert();
                  } else {
                    setShowDeclinePopup(true);
                  }
                } else {
                  handleConfirmAlert();
                }
              }

              if (!hasAccess) {
                navigate("/feature_not_assigned", {
                  state: { unavailableService: "AInternalTxn" },
                });
                return;
              }
            }}
            enabledBgColor={
              hasAccess ? "var(--negative-act)" : "var(--text-disabled)"
            }
            hoverOption={"dark"}
            inActiveVariantNeeded
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={!hasAccess}
          >
            <InternalTransactionViewAll
              typepop={"RejectInternalAcc"}
              type={ associateType === "rejectAccount"
              ? "Internal_AccountApproval"
              : "RejectInternalTxn"}
              internal_acc_id={
                type === "internalAccountApproval"
                  ? associatePopupDate?.accId
                  : internalAccount?.id
              }
              // internal_acc_name={
              //   type === "internalAccountApproval"
              //     ? associatePopupDate?.accName
              //     : internalAccount?.name
              // }
              bank_acc_no={
                type === "internalAccountApproval"
                  ? associatePopupDate?.accNumber
                  : internalAccount?.bank_acc_no
              }
              OwnerDetail={true}
              balanceType={globalText?.CREDIT}
              BeneAccId={ type === "internalAccountApproval"
                  ? associatePopupDate?.accId : internalAccount?.id}

              setShowLoader={setShowLoader}
              setSidebarState={(e) => {}}
              setFocus={(e) => {}}
            />
          </LargePopupRedirect>
        </div>
      )}

      {showScheduleTxnPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center  z-z-index-max">
          <ScheduleInternalTransactionViewAllPopup
            onClose={() => {
              setShowScheduleTxnPopup(false);
              setDeclineReason("");
              setAssociateType("");
              setShowDeclinePopup(false);
              if (type === "internalAccountApproval") {
                 handleClosePopup()
              }
            }}
            headerTitle={globalText?.ASSOCIATED_SCHEDULES_FOUND}
            headerSubtitle={globalText?.REJECT_LINKED_SCHEDULES_NOTE}
            showFooter
            footerTitle={
              hasScheduleAccess
                ? globalText?.SCHEDULE_REJECTALL_NOTE
                : globalText?.REJECT_SCHEDULE_CONTACT_NOTE
            }
            showFooterButton
            footerButtonText="Reject all"
            footerButtonDisabled={!hasScheduleAccess}
            footerButtonBackgroundColor={
              !hasScheduleAccess
                ? "var(--text-disabled)"
                : "var(--negative-act)"
            }
            inActiveVariantNeeded={true}
            onFooterButtonClick={() => {
              const servicesReq = ["IAScheduledTxn"];

              if (servicesReq.some((service) => services.includes(service))) {
                if (associateType === "scheduleInternalTxn") {
                  if (
                    declineReason &&
                    declineReason.length >= GlobalConfiguration.panLength
                  ) {
                    handleRejectScheduleInternalTxn();
                  } else {
                    setShowDeclinePopup(true);
                  }
                } else {
                  handleRejectScheduleInternalTxn();
                }
              }

              if (!hasScheduleAccess) {
                navigate("/feature_not_assigned", {
                  state: { unavailableService: "IAScheduledTxn" },
                });
                return;
              }
            }}
            contentProps={{
              type: "scheduleInternalAcc",
              txnHistorytype: "scheduleInternalAccApproval",
              internal_account_id:
                type === "internalAccountApproval"
                  ? associatePopupDate?.accId
                  : internalAccount?.id,
              internal_account_name:
                type === "internalAccountApproval"
                  ? associatePopupDate?.accName
                  : internalAccount?.name,
              onClose: undefined,
            }}
          />
        </div>
      )}
    </>
  );
};

export default InternalRejectAllPopup;
